<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-user-view">
		<table>
			<caption></caption>
			<thead>
				<tr>
					<th scope="col"></th>
				</tr>
			</thead>
			<tr>
				<td class="font-semibold">{{ $t("UploadFiles.File") + " " + "No:" }}</td>
				<td>{{ data.body.upload_file_id }}</td>
			</tr>
			<tr>
				<td class="font-semibold">{{ $t("ManualData.AddedOn") }}</td>
				<td>{{ data.added_on }}</td>
			</tr>
		</table>
		<div class="vx-row">
			<div class="vx-col w-full md:w-1/2 pr-1">
				<vx-card card-border>
					<div
						:class="{
							'flex justify-between flex-row-reverse items-center': iconRight,
							'text-center': !iconRight,
						}"
						:title="$t('Group.TotalCreated')"
					>
						<span class="inline-flex rounded-full" :class="[`text-${color}`, {'mb-4': !iconRight}]">
							<i class="material-icons">where_to_vote</i>
						</span>
						<div class="truncate">
							<span class="font-semibold text-sm">{{ $t("Group.TotalCreated") }}</span>
							<h4
								class="mb-1 font-bold"
								:class="data.body.total_saved > 0 ? 'underline cursor-pointer' : ''"
								@click.prevent="goToListVisitPoint(data.body.total_saved)"
							>
								{{ data.body.total_saved }}
							</h4>
						</div>
					</div>
				</vx-card>
			</div>
			<div class="vx-col w-full md:w-1/2 pl-0">
				<vx-card card-border>
					<div
						:class="{
							'flex justify-between flex-row-reverse items-center': iconRight,
							'text-center': !iconRight,
						}"
						:title="$t('Group.TotalErrors')"
					>
						<span class="inline-flex rounded-full" :class="[`text-${color}`, {'mb-4': !iconRight}]">
							<i class="material-icons">location_off</i>
						</span>
						<div class="truncate">
							<span class="font-semibold text-sm">{{ $t("Group.TotalErrors") }}</span>
							<h4
								class="mb-1 font-bold"
								:class="data.body.total_manual_data > 0 ? 'underline cursor-pointer' : ''"
								@click.prevent="goToManualData(data.body.total_manual_data)"
							>
								{{ data.body.total_manual_data }}
							</h4>
						</div>
					</div>
				</vx-card>
			</div>
			<div class="vx-col w-full md:w-1/2 pr-1 pt-1">
				<vx-card card-border>
					<div
						:class="{
							'flex justify-between flex-row-reverse items-center': iconRight,
							'text-center': !iconRight,
						}"
						:title="$t('RouterSelection.Total') + ' ' + 'GeoCoder'"
					>
						<span class="" :class="[`text-${color}`, {'mb-4': !iconRight}]">
							<i class="material-icons">my_location</i>
						</span>
						<div class="truncate">
							<span class="font-semibold text-sm">{{
								$t("RouterSelection.Total") + " " + "GeoCoder"
							}}</span>
							<h4 class="mb-1 font-bold">{{ data.body.total_to_geinverso }}</h4>
						</div>
					</div>
				</vx-card>
			</div>
			<div class="vx-col w-full md:w-1/2 pl-0 pt-1">
				<vx-card card-border>
					<div
						:class="{
							'flex justify-between flex-row-reverse items-center': iconRight,
							'text-center': !iconRight,
						}"
						:title="$t('RouterSelection.Total') + ' ' + 'GeoInverso'"
					>
						<span class="inline-flex rounded-full" :class="[`text-${color}`, {'mb-4': !iconRight}]">
							<i class="material-icons">location_searching</i>
						</span>
						<div class="truncate">
							<span class="font-semibold text-sm">{{
								$t("RouterSelection.Total") + " " + "GeoInverso"
							}}</span>
							<h4 class="mb-1 font-bold">{{ data.body.total_to_geocoder }}</h4>
						</div>
					</div>
				</vx-card>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		data: {
			type: Object,
		},
		iconRight: {
			type: Boolean,
			default: false,
		},
		color: {
			type: String,
			default: "primary",
		},
		colorTo: {
			type: String,
		},
		type: {
			type: String,
			default: "line",
		},
	},
	filters: {
		removeDecimals(num = 0.03) {
			return num.toFixed(1);
		},
	},
	methods: {
		goToManualData(val) {
			if (val > 0) this.$router.push({name: "app-upload-file-list"});
		},
		goToListVisitPoint(val) {
			if (val > 0) this.$router.push({name: "app-visit-point-list"});
		},
	},
};
</script>

<style lang="scss">
#avatar-col {
	width: 10rem;
}

#page-user-view {
	table {
		td {
			vertical-align: top;
			min-width: 140px;
			padding-bottom: 0.8rem;
			word-break: break-all;
		}

		&:not(.permissions-table) {
			td {
				@media screen and (max-width: 370px) {
					display: block;
				}
			}
		}
	}
}

@media screen and (min-width: 1201px) and (max-width: 1211px),
	only screen and (min-width: 636px) and (max-width: 991px) {
	#account-info-col-1 {
		width: calc(100% - 12rem) !important;
	}
}
</style>
